import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
  config_info: null, // 网站基本信息
  userInfo: null, // 用户信息

  logined: false, // 是否登录

  unread: 0,

  balance: {
    all: 0,
    data: null
  }, // 用户余额

  my_bankCard: [], // 绑定的银行列表

  bill_group: [], // 记录分组数据

  lotteryMenu: null, // 彩种分类数据
  lotteryList: [], // 购彩大厅要显示的彩种
  groupLotteryList: [], // 购彩大厅要显示某种分类的彩种
  lottery_load: false, // 显示加载
  betArr: [], // 保存投注信息

  levelInfo: null, // 等级，收件箱未读数等信息
  config_foot: [], // 页面底部信息
  noticeList: [], // 公告通知
  siteName: process.env.siteName // 站名
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js